/* eslint-disable import/no-default-export */
import React, { Suspense } from 'react';

import { connect } from 'react-redux';

import { OverlayType } from 'app/gamma/src/modules/state/ui/overlay';
import { State } from 'app/gamma/src/modules/types';
import { getActiveOverlay } from 'app/gamma/src/selectors/overlays';
import { useLazyComponent } from '@trello/use-lazy-component';

interface OverlaysProps {
  overlay: string | null;
}

const Overlays = ({ overlay }: OverlaysProps) => {
  let component;

  const CreateBoardOverlay = useLazyComponent(() =>
    import(
      /* webpackChunkName: "create-board-overlay" */ './create-board-overlay'
    ),
  );

  const ClosedBoardsOverlay = useLazyComponent(() =>
    import(
      /* webpackChunkName: "closed-boards-overlay" */ './closed-boards-overlay'
    ),
  );

  const CreateTeamOverlay = useLazyComponent(() =>
    import(
      /* webpackChunkName: "gamma-create-team-overlay" */ './create-team-overlay'
    ),
  );

  const CrossFlowOverlay = useLazyComponent(() =>
    import(
      /* webpackChunkName: "gamma-cross-flow-overlay" */ './cross-flow-overlay'
    ),
  );

  switch (overlay) {
    case OverlayType.CreateBoard:
      component = <CreateBoardOverlay />;
      break;
    case OverlayType.ClosedBoards:
      component = <ClosedBoardsOverlay />;
      break;
    case OverlayType.CreateTeam:
      component = <CreateTeamOverlay />;
      break;
    case OverlayType.CrossFlow:
    case OverlayType.ProductStore:
      component = <CrossFlowOverlay />;
      break;
    default:
      component = null;
  }

  return <Suspense fallback={null}>{component}</Suspense>;
};

const mapStateToProps = (state: State) => {
  return {
    overlay: getActiveOverlay(state),
  };
};

export default connect(mapStateToProps)(Overlays);
